// Endpoint URLs come from the ADR-007 runtime config (window.__GMS_RUNTIME_CONFIG__,
// set by /runtime-config.js before the bundle loads), NOT from build-time env
// vars — so one built bundle is promoted unchanged across dev/qa/stage/prod.
// See src/config/runtimeConfig.ts.
import runtimeConfig from '../config/runtimeConfig';

const APP_ENVIRONMENT = "DEV";
const LOGS_ENABLED = true;
const APP_NAME = "GMS Frontend";
const APP_CODE = "GMS";

const gmsConfig = {
  GMS_BACKEND_API_URL: runtimeConfig.GMS_BACKEND_API_URL,
  PROMOTION_API: runtimeConfig.ARS_PROMOTION_API_URL,
  APP_ENVIRONMENT: APP_ENVIRONMENT,
  LOGS_ENABLED: LOGS_ENABLED,
  SAMS_SSO_URL: runtimeConfig.SAMS_SSO_URL,
  SAMS_API_URL: runtimeConfig.SAMS_API_URL,
  APP_NAME: APP_NAME,
  // Retired 2026-07-30 with the DB Promoter card and the admin Task Queue screen. Both backends are
  // gone: GET /dbpromoter/server/list/:querysetid now returns 404 and the Task Queue route is
  // commented out in App.tsx.
  // DBPROMOTER_APP_URL: runtimeConfig.DBPROMOTER_APP_URL,
  // TASKQUEUE_WORKER_INFO_URL: runtimeConfig.TASKQUEUE_WORKER_INFO_URL,
  APP_CODE: APP_CODE,
  ISR_BACKEND_URL: runtimeConfig.ISR_BACKEND_URL,
  ISR_RUNTIME_URL: runtimeConfig.ISR_RUNTIME_URL
}

export default gmsConfig;
